import React, { FC } from 'react'
import { useSelector } from 'react-redux'

import { EuiCodeBlock, EuiText } from '@elastic/eui'

import { PermissionType } from '../../api/interfaces'
import { RootState } from '../../app/rootReducer'
import { useOrganizationPermissions } from '../../providers/OrganizationPermissionsContext'

interface IAudiencePixelProps {
  showDescription: boolean
}

export const audiencePixelDescription = 'Placing the audience pixel on your website (and/or landing pages) enables more advanced audience analytics across all your campaigns and provides additional targeting methods.'

export const AudiencePixel: FC<IAudiencePixelProps> = ({ showDescription }) => {
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const { hasPermission } = useOrganizationPermissions()

  if (!currentAccount) {
    return null
  }

  return (
    <>
      <EuiText>
        {showDescription && <p>{audiencePixelDescription}</p>}
        <h3>Audience Pixel Code</h3>
        <p>Place the code below on every page of your website.</p>
        <EuiCodeBlock language='html' fontSize='m' paddingSize='m' color='dark' isCopyable>{`<script src="https://apxl.io/script.js?id=${currentAccount.id}" />`}</EuiCodeBlock>
      </EuiText>
      {hasPermission(PermissionType.ShowCustomizablePixel) && (
        <EuiText>
          <h3>Customizable Pixel</h3>
          <EuiCodeBlock language='html' fontSize='m' paddingSize='m' color='dark' isCopyable>{`<img src="https://apxl.io/${currentAccount.id}/cp" width="1" height="1" alt="cp"/>`}</EuiCodeBlock>
        </EuiText>
      )}
    </>
  )
}
